import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import system from './modules/system'
import auth from './modules/auth'
import authRepo from "./../api/repos/authRepo";
import NProgress from 'nprogress'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 70 }, // clear the sticky header
        behavior: 'smooth'
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    ...system,
    ...auth,
  ]
})

NProgress.configure({ showSpinner: false, trickleSpeed: 120 })


/// ////////////////////
// Before Each Route //
/// ////////////////////
router.beforeEach(async (to, from, next) => {

  NProgress.start()

  // load view layout
  store.commit('app/setLayout', to.meta.layout + '-layout')

  await checkAuth();



  // Auth Required Pages
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        name: 'login'
      })
    } else {
      next()
    }

    // guest only pages
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: 'home'
      })
    }
    // pages for both guest and authorized users
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

router.onError(() => {
  NProgress.done()
})

let checkAuth = async () => {
  const token = localStorage.getItem('token')

  // If no token, clear auth and skip auth check to avoid 401 redirects on public pages
  if (token == null) {
    store.commit('user/clearAuth')
    return
  }

  try {
    await authRepo.isLoggedIn()

    // If token exists but Vuex doesn't, sync from localStorage
    if (store.getters['user/token'] == null) {
      store.commit('user/setAuth')
    }
  } catch (e) {
    store.commit('user/clearAuth')
    localStorage.removeItem('user')
    localStorage.removeItem('token')
  }
}

export default router
